<div class="background-overlay">
  @if (showBackgroundLottie()) {
    <!-- Layer 1: Background Lottie (deepest layer) -->
    <ng-lottie class="background-lottie" [class.opacity]="addOpacity()" [options]="bdcAnimOptions" (animationCreated)="bdcAnimationCreated($event)"></ng-lottie>
  }

  @if (showGroup1Lottie()) {
    <!-- Layer 2: Group 1 Lottie (middle layer) -->
    <ng-lottie class="group1-lottie" [options]="geoAnimOptions" (animationCreated)="geoAnimationCreated($event)"></ng-lottie>
  }

  @if (showModuleImage() && moduleImageSrc) {
    <!-- Layer 3: Module Image (top layer) -->
    <img class="module-image" [src]="moduleImageSrc" alt="Module background" draggable="false" />
  }
</div>
